
<template>

    <div>
        <div class="nav">
            <v-head></v-head>
        </div>
        <v-route :bindData="bindData"></v-route>
        <div class="container">
            <v-breadcrumb value1="首页" value2="虚拟游" value3="720°全景游览" :url="url"></v-breadcrumb>
            <div class="container_box">
                <!--<div class="box_top">
                    <span >廉江动态</span>丨<span> 最热 </span>丨<span> 最新 </span>丨<span> 精华 </span>
                </div>-->

                <div class="box_item mt20" v-for="i in dataList" @click="showVr(i)">
                    <img class="i" :src="i.coverImageUrl">
                    <div class="right_down hover" >                      
                      <img src="../../assets/img/ljlj/mp4.png">  {{i.title}}
                    </div>
                    <div class="cover hover">
                        <img src="../../assets/img/ljlj/play.png">

                    </div>
             </div>
            </div>
        </div>

        <div class="vr" v-show="show" >
            <div class="iframe" >

                <iframe id="iframe"  style="width: 100%;height: 100%" :src="vr.href"></iframe>

            </div>
            <div class="vr-list" ref="vr-list">

                <div ref="title" class="title">
                  景区列表
                    <img src="../../assets/img/ljlj/close.png" @click="closeVr">

                </div>
                <div ref="detail" class="detail">

                    <div @click="selectVr(i)" :class="{detail_item:true,active:(i.href == vr.href)}" v-for="i in dataList" :style="{'background': 'url('+i.coverImageUrl+')','background-size':'cover'}">
                        <div class="detail_bottom">
                            {{i.title}}
                        </div>
                    </div>

                </div>
                <svg @click="changeList" ref="icon1" t="1594714102648" class="icon hover" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5120" width="200" height="200"><path d="M802.88 512L384 930.88l93.12 93.12 512-512-512-512L384 93.12 802.88 512z m-384 0L0 930.88 93.12 1024l512-512-512-512L0 93.12 418.88 512z" fill="#1296db" p-id="5121"></path></svg>
                <svg style="display: none" @click="changeList2" ref="icon2" t="1594714518288" class="icon hover" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5445" width="200" height="200"><path d="M186.24 512l418.88 418.88L512 1024 0 512 512 0l93.12 93.12L186.176 512z m384 0l418.88 418.88L896 1024 384 512 896 0l93.12 93.12L570.176 512z" fill="#1296db" p-id="5446"></path></svg>
            </div>

        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
    import route from '../../components/common/route1'
    export default {
        name: "list1",
        data(){
            return{
                fullscreenLoading:false,
                ljcode:null,
                columnId:null,
                rootColumnId:null,
                dataList:null,
                url:null,
                value2:null,
                value3:null,
                bindData:[
                    {
                        name:'720°全景游览',
                        url:'#/vr?ljcode=720&columnId=40288a9d6e91c70a016e91cc6eb5000a&rootColumnId=40288a9d6e91c70a016e91c895ae0001',
                        cid:'40288a9d6e91c70a016e91cc6eb5000a'
                    },
                    {
                        name:'漫游讲解',
                        url:'#/myjj?ljcode=myjj&columnId=2c9a4c9b6ea63d8c016ea6474f040002&rootColumnId=40288a9d6e91c70a016e91c895ae0001',
                        cid:'2c9a4c9b6ea63d8c016ea6474f040002'
                    },
                    {
                        name:'场景切换',
                        url:'#/cjqh?ljcode=cjqh&rootColumnId=40288a9d6e91c70a016e91c895ae0001&columnId=cjqh',
                        cid:'cjqh'
                    }
                ],
                show:false,
                vr:{href:''
                }

            }
        },
        watch:{
            show:function (newValue) {
                console.log(newValue)
                if(newValue){
                    document.body.style.overflow = 'hidden'
                }else {
                    document.body.style.overflow = ''
                }
            }
        },
        created() {
            this.ljcode = this.$route.query.ljcode;
            this.columnId = this.$route.query.columnId;
            this.rootColumnId = this.$route.query.rootColumnId;
            this.url = [this.ljcode,this.rootColumnId,this.columnId];
            this.getList();
        },
        methods:{
            changeList(){
                this.$refs['vr-list'].style.width = '70px';

                this.$refs['vr-list'].style['-webkit-transition'] = 'width 1s linear'
                this.$refs['vr-list'].style['transition'] = 'width 1s linear'
                this.$refs['vr-list'].style['-moz-transition'] = 'width 1s linear'
                this.$refs['vr-list'].style['-o-transition'] = 'width 1s linear'

                this.$refs['detail'].style.display = 'none'
                this.$refs['title'].style.display = 'none'
                this.$refs['icon1'].style.display = 'none'
                this.$refs['icon2'].style.display = 'block'

            },
            changeList2(){
                this.$refs['vr-list'].style.width = '480px';
                this.$refs['detail'].style.display = 'block'
                this.$refs['title'].style.display = 'block'
                this.$refs['icon1'].style.display = 'block'
                this.$refs['icon2'].style.display = 'none'
            },
            selectVr(v){
                this.vr = {
                    href: v.href
                }
                var loading = this.$loading({
                    lock: true,
                    text: '加载中,请等待',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                document.getElementById('iframe').onload=function(){
                    setTimeout(()=>{
                        loading.close();
                    },2000)
                }
            },
            closeVr(){
                this.vr = {"href":''}
                this.show = false;
            },
            showVr(v){
                console.log(v,"v")
                
               this.vr={
                   href : v.href     
               };

               this.show = true;
                var loading = this.$loading({
                    lock: true,
                    text: '加载中,请等待',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                document.getElementById('iframe').onload=function(){
                    setTimeout(()=>{
                        loading.close();
                    },2000)

                }
            },
            getList(){
                let that = this;
                let url = `${api}/api/cms/article/list?rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&type=&pageSize=100&currentPage=1`;
                this.common.axios.get(url).then(v=>{
                    console.log(v.data.data)
                    let data = v.data.data.list;
                    data.forEach(v=>{
                        v.coverImageUrl = apiimg+v.coverImageUrl;
                        v.path = `ljcode=${this.ljcode}&rootColumnId=${this.rootColumnId}&columnId=${this.columnId}&articleId=${v.id}`;
                        v.time = that.common.date2Local(v.createDate);
                    });                
                    this.dataList = data;                  
                    console.log(data,"data");
                })
            },
            toDetail(v){
                this.$router.push({path:`/detail2?${v}`})
            }
        },
        components:{
            "v-route":route
        }
    }
</script>

<style lang="less" scoped>
    .nav{
        height: 350px;
        background: url("../../assets/img/ljlj/lake.png");
    }
    .container_box{
        display: flex;
        flex-wrap: wrap;
        .box_item{
            height: 277px;
            width: 360px;
            border-radius:4px;
            margin-bottom: 20px;
            position: relative;
            margin-right: 20px;
            .i{
                width: 360px;
                height: 237px;
            }
            .right_down{
                width: 100%;
                position: absolute;
                bottom: 0;
                height: 20px;
                line-height: 20px;
                text-align: left;
                font-size:14px;
                img{
                    position: relative;
                    top: 2px;
                    margin-right: 10px;
                }
            }
            .cover{
                width: 360px;
                height: 237px;
                background: rgba(0,0,0,0.4);
                position: absolute;
                top: 0;
                text-align: center;
                img{
                    position: relative;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }

        }

    }

    .vr{
        z-index:999;
        position: fixed;
        top: 0;
        height: 100vh;
        width: 100vw;
        display: flex;
        background: rgb(0,0,0);
        .iframe{
            flex: 1;
        };
        .vr-list{
            width: 480px;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .icon{
                width: 40px;
                height: 60px;
                position: absolute;
                left: 20px;
                top: 50%;
            }
            .title{
                height: 70px;
                line-height: 70px;
                position: relative;
                text-align: left;
                font-size: 25px;
                color: white;
                padding-left: 40px;
                width: 100%;
                img{
                    position: absolute;
                    right: 50px;
                    width: 70px;
                    height: 70px;
                    z-index: 9999;
                }
            }
            .detail{
                width: 80%;
                flex: 1;
                overflow-y: scroll;
                height: 0;
                .detail_item{
                    margin: 0 auto;
                    height: 190px ;
                    width: 288px;
                    position: relative;
                    margin-bottom: 20px;
                    .detail_bottom{
                        position: absolute;
                        bottom: 0;
                        height: 40px;
                        line-height: 40px;
                        background: rgba(0,0,0,0.4);
                        color: white;
                        font-size: 20px;
                        width: 100%;
                        padding-left: 20px;
                    }
                }
                .active{
                 border: 8px solid rgb(252,101,0);
                }
            }
        }
    }


</style>
<style>

    .detail::-webkit-scrollbar {/*滚动条整体样式*/

        width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/

        height: 1px;


    }

    .detail::-webkit-scrollbar-thumb {/*滚动条里面小方块*/


        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);

        background: rgb(255,102,0);

    }

    .detail::-webkit-scrollbar-track {/*滚动条里面轨道*/

        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);


        background: rgb(26,26,26);

    }
</style>
